/**
 * UiBlocks text utilities
 */

const DEFAULT_NAME_MAX_LENGTH = 70
const COMBINED_NAME_MAX_LENGTH = 75

/**
 * Truncate product name to max length with ellipsis
 */
export function truncateName(name: string, maxLength = DEFAULT_NAME_MAX_LENGTH): string {
  if (name.length <= maxLength) return name
  return `${name.substring(0, maxLength - 3)}...`
}

/**
 * Truncate two combined name strings to fit within max length.
 * Primary name is preserved, secondary is truncated if needed.
 *
 * @returns Tuple of [adjustedPrimary, adjustedSecondary]
 */
export function truncateCombinedNames(
  primaryName: string,
  secondaryName: string | null | undefined,
  maxLength = COMBINED_NAME_MAX_LENGTH
): [string, string] {
  let name1 = primaryName || ''
  const name2 = secondaryName || ''

  if (name1 && name2) {
    name1 += ' '
  }

  const totalLength = name1.length + name2.length
  if (totalLength <= maxLength) return [name1, name2]

  const availableForName2 = maxLength - name1.length
  if (availableForName2 <= 3) return [name1, '']

  return [name1, `${name2.slice(0, availableForName2 - 3)}...`]
}
